import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';

import DashboardIcon from '@material-ui/icons/Dashboard';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import DeviceHubIcon from '@material-ui/icons/DeviceHub';
import TimelapseIcon from '@material-ui/icons/Timelapse';
import ScheduleIcon from '@material-ui/icons/Schedule';
import TimelineIcon from '@material-ui/icons/Timeline';


import BarChartIcon from '@mui/icons-material/BarChart';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import ElderlyIcon from '@mui/icons-material/Elderly';
import InsightsIcon from '@mui/icons-material/Insights';

import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';;
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle';
import AirlineSeatFlatIcon from '@material-ui/icons/AirlineSeatFlat';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

import Typography from '@material-ui/core/Typography';

import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Profile, SidebarNav } from './components';
import { CONFIG_SETTINGS, USERAUTH_ADMIN } from 'config.js';


import { FormattedMessage } from "react-intl";


const AiBadge = () => (
  <sup style={{ marginLeft: 4, fontSize: 10, fontWeight: 700, color: '#4F46E5' }}>AI<sup>+</sup></sup>
);


const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    // backgroundColor: "#1a1a1a",
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2),
    // JustifyContent: 'flex-start',
  },

  dividerInset: {
    margin: `5px 0 0 ${theme.spacing(9)}px`,
  },
}));



const Sidebar = props => {
  const { open, variant, onClose, className, router, tempSetUser, ...rest } = props;

  const classes = useStyles();

  const userAuth = useSelector((state) => state.user.admin_type);


  const userjson = localStorage.getItem(CONFIG_SETTINGS.USER_INFO);
  if(!userjson) {
    setTimeout( () => {
      window.location.href = '/sign-in';
    }, 100);
  }

  var pages = [

      {
        title: <span><FormattedMessage id="dashboard"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} /><AiBadge /></span>,
        href: '/dashboard',
        icon: <DashboardIcon />
      },

      {
        title: <FormattedMessage id="emergency_history_query"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/emergencyHistory',
        disable: false,
        // icon: <ScheduleIcon />
        icon: <NotificationsActiveIcon />
      },

      {
        title: <FormattedMessage id="wakeup_history_query"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/wakeupHistory',
        disable: false,
        icon: <ElderlyIcon />
      },

    ];


    var pages_bigdata = [
      {
        title: <FormattedMessage id="healthdata_sensor_heatmap"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/sensorHeatmap',
        disable: false,
        icon: <BlurOnIcon />
      },
      {
        title: <span><FormattedMessage id="healthdata_query_daily"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} /><AiBadge /></span>,
        href: '/healthdataByDate',
        disable: false,
        icon: <TimelineIcon />
      },

      {
        title: <span><FormattedMessage id="healthdata_query_by_room"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }}/><AiBadge /></span>,
        href: '/healthdataByRoom',
        disable: false,
        icon: <BarChartIcon />
      },

      // {
      //   title: '헬스데이터조회-검토필요',
      //   href: '/usages',
      //   disable: true,
      //   icon: <TimelapseIcon />
      // },


    ];


    var pages_ai_insight = [
      {
        title: <span><FormattedMessage id="ai_report_query"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} /><AiBadge /></span>,
        href: '/aiReport',
        disable: false,
        icon: <InsightsIcon />
      },

      // {
      //   title: '보호자상담',
      //   href: '/chargers',
      //   disable: true,
      //   icon: <PeopleIcon />
      // },
      // {
      //   title: '이용요금결제',
      //   href: '/chargers',
      //   disable: true,
      //   icon: <PeopleIcon />
      // },
      // {
      //   title: '회원관리',
      //   href: '/members',
      //   icon: <PeopleIcon />
      // },
      // {
      //   title: '공지사항',
      //   href: '/notice',
      //   icon: <NotificationsIcon />
      // },
      // accountPage,
    ];


  var pages2 = [
      {
        title: <FormattedMessage id="sensor_device"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/devices',
        icon: <DeviceHubIcon />
      },
      {
        title: <FormattedMessage id="room_manager"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/rooms',
        icon: <AssignmentIndIcon />
      },
      {
        title: <FormattedMessage id="caregiver_manager"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }} />,
        href: '/caregivers',
        icon: <AssignmentIndIcon />
      },
      {
        title: '환자관리',
        title: <FormattedMessage id="patient_manager"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }}/>,
        href: '/patients',
        icon: <AirlineSeatFlatIcon />
      },
      // accountPage,
    ];

  var pages3 = [
      {
        title: <FormattedMessage id="app_acount"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }}/>,
        href: '/auth',
        disable: userAuth === USERAUTH_ADMIN ? false : true,
        icon: <SupervisedUserCircleIcon />
      },
      {
        title: <FormattedMessage id="environments_settings"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }}/>,
        href: '/settings',
        disable:false,
        icon: <SupervisedUserCircleIcon />
      },
      {
        title: <FormattedMessage id="notice_board"
                defaultMessage="could not find a message. (locale: {locale})"
                values={{ locale: localStorage.getItem("locale") }}/>,
        href: '/notice',
        disable:true,
        icon: <NotificationsIcon />
      },
      // accountPage,
    ];


  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >

        <Profile />

        <Divider className={classes.divider} />

        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
        <Divider variant="inset"  />


        <Typography
          className={classes.dividerInset}
          color="textSecondary"
          display="block"
          variant="caption"
        >
          <FormattedMessage id="bigdata" />
        </Typography>

        <SidebarNav
          className={classes.nav}
          pages={pages_bigdata}
        />

        <Divider variant="inset"  />

        <Typography
          className={classes.dividerInset}
          color="textSecondary"
          display="block"
          variant="caption"
        >
          <FormattedMessage id="ai_insight_group" />
        </Typography>

        <SidebarNav
          className={classes.nav}
          pages={pages_ai_insight}
        />

        <Divider variant="inset"  />

        <Typography
          className={classes.dividerInset}
          color="textSecondary"
          display="block"
          variant="caption"
        >
          <FormattedMessage id="settings" />
        </Typography>

        <SidebarNav
          className={classes.nav}
          pages={pages2}
        />


        <Divider variant="inset"  />
        <Typography
          className={classes.dividerInset}
          color="textSecondary"
          display="block"
          variant="caption"
        >
          <FormattedMessage id="admin" />
        </Typography>

        <SidebarNav
          className={classes.nav}
          pages={pages3}
        />

        <div style={{position:"absolute", paddingRight:"10px", bottom:"10px", fontSize:"10px", fontWeight:"bold" }}>
          Copyright(c) 2021 BigHaveSolution, Inc.
          All rights Reserved
        </div>
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  router: PropTypes.object
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch)
}

let mapStateToProps = (state) => {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Sidebar);

